import { useTranslation } from 'react-i18next'
import { Language } from '@dentalux/ui-library-core/src/type/Translations'

export const useLanguage = (): Language => {
  const { i18n } = useTranslation()

  return i18n.language as Language
}
